// test2707
(2707 && 0);
